/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StoricoEntryDTO } from './storico-entry-dto';


export interface StoricoSnapshotDTO { 
    root?: Array<StoricoEntryDTO>;
    anagrafica?: Array<StoricoEntryDTO>;
    componenti?: { [key: string]: Array<StoricoEntryDTO>; };
    eav?: Array<StoricoEntryDTO>;
}

